module.exports = __webpack_public_path__ + "18081dd76bd0308c665d2281dd7d445c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-48@2x.png
// module id = 520
// module chunks = 0